import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { Entry } from 'contentful';
import { OfflineAirlineProfileTableSectionComponent } from 'src/app/component/shared/offline-airline-profile-table-section/offline-airline-profile-table-section.component';
import { TableSectionComponent } from 'src/app/component/shared/table-section/table-section.component';
import { OfflineAirlinePage } from 'src/app/model/page/group/api-docs/offline-airline-profile-page';
import { ContentfulService } from 'src/app/service/contentful.service';
import { SharedDataService } from 'src/app/service/shared-data.service';
import { ModelValidator } from 'src/app/validator/model-validator';
import htmlTitle from 'src/assets/json/redirects/html-title.json';

@Component({
  selector: 'app-offline-airline-page',
  templateUrl: './offline-airline-page.component.html',
  styleUrls: ['./offline-airline-page.component.scss']
})
export class OfflineAirlinePageComponent implements OnInit {
  @Input() pageTitle = '';

  @ViewChild(OfflineAirlineProfileTableSectionComponent)
  offlineAirlineProfileTableSectionComponent!: OfflineAirlineProfileTableSectionComponent;

  offlineAirlinePage: OfflineAirlinePage = {} as OfflineAirlinePage;

  constructor(private contentfulService: ContentfulService, private sharedDataService: SharedDataService) {}

  ngOnInitWithPageTitle(pageTitle: string) {
    this.pageTitle = pageTitle;
    this.ngOnInit();
  }

  ngOnInit(): void {
    htmlTitle.filter((title) => {
      if (title.page === 'offline-airline-profile') {
        this.offlineAirlinePage.htmlTitle = title.htmlTitle;
      }
    });
    const query = { 'fields.title': 'Offline Airline Profile-File List' };

    this.contentfulService.getPageContentWithEntries(query).then((offlineAirlinePageEntries) => {
     
      this.offlineAirlinePage.tableSections = [];
      this.mapBanners(offlineAirlinePageEntries, query);
      this.sharedDataService.addSharedData(this.offlineAirlinePage.banner);
      this.mapTableSections(offlineAirlinePageEntries);
    });
  }

  private mapBanners(offlineAirlinePageEntries: Entry<any>[], query: any) {
    if (offlineAirlinePageEntries) {
      offlineAirlinePageEntries
        .filter((entry) => ModelValidator.isBanner(entry))
        .forEach((entry) => {
          this.mapEntryToBanner(entry);
        });
    }
  }

  private mapEntryToBanner(entry: Entry<any>) {
    let imageDetails: any = entry.fields['image'];
    let videoDetails: any = entry.fields['video'];

    this.offlineAirlinePage.banner = {
      title: entry.fields['title'] as string,
      subTitle: entry.fields['subTitle'] as string,
      image: imageDetails.fields.file.url,
      video: videoDetails?.fields?.file?.url
    };
  }

  private mapTableSections(offlineAirlinePageEntries: Entry<any>[]) {
    offlineAirlinePageEntries
      .filter((entry) => ModelValidator.isTableSection(entry))
      .forEach((entry) => {
        this.mapTables(entry);
      });
  }


  private mapTables(entry: Entry<any>) {
    let givenTitle: any = entry.fields['title'] as string;
    let pageTitle = givenTitle.split('#').pop();

    let table = {
      title: pageTitle,
      body: entry.fields['body'] as string,
      order: entry.fields['order'] as number,
      group: entry.fields['group'] as string,
      table: entry.fields['table'] as string,
      heading: entry.fields['heading'] as string,
      url: entry.fields['url'] as string
   
    };
    this.offlineAirlinePage.tableSections.push(table);
    this.offlineAirlinePage.tableSections.sort((a, b) => a.order - b.order);
  }
 
}